import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  DatePicker,
  DatePickerAnchorField,
} from 'components/global/CUK/DatePicker'
import { SxProps } from '@mui/system'
import {
  getDateRangeKind,
  trackEvent,
} from 'analytics'

type IDateFilterProps = {
  startDate?: Date | null | undefined
  endDate?: Date | null | undefined
  placeholderKey: string
  onStartDateChange?: (start: null|Date) => void
  onEndDateChange?: (start: null|Date) => void
  onSubmit?: (start: null|Date, end: null|Date) => void
  onReset: () => void
  inputSx?: SxProps
  displayStartAdornment?: boolean
  blockFutureDates?: boolean
  blockPastDates?: boolean
  showPresets?: boolean
  showPresetLabel?: boolean
  defaultPreset?: string
  analyticsName?: string
  placement?: 'top-start' | 'top' | 'top-end' | 'right-start' | 'right' | 'right-end' | 'bottom-start' | 'bottom' | 'bottom-end' | 'left-start' | 'left' | 'left-end'
}

const DateFilter = ({
  startDate = null,
  onStartDateChange = () => {},
  endDate = null,
  onEndDateChange = () => {},
  onSubmit = () => {},
  onReset,
  placeholderKey,
  inputSx,
  blockFutureDates = false,
  blockPastDates = false,
  showPresets = false,
  showPresetLabel = false,
  defaultPreset,
  analyticsName = 'date_range',
  placement = 'bottom-start'
}: IDateFilterProps) => {
  const { t } = useTranslation()
  const methods = useForm({
    defaultValues: {
      presetSelection: defaultPreset
    }
  })

  return (
    <FormProvider {...methods}>
      <DatePicker
        showPresets={showPresets}
        showPresetLabel={showPresetLabel}
        blockFutureDates={blockFutureDates}
        blockPastDates={blockPastDates}
        placement={placement}
        defaultStartDate={startDate}
        defaultEndDate={endDate}
        defaultPreset={defaultPreset}
        field={
          <DatePickerAnchorField
            isdate={true}
            inputSize="small"
            locale="fr"
            startDate={startDate}
            endDate={endDate}
            onReset={() => {
              trackEvent('filter_cleared', { filter_name: analyticsName })
              onReset()
            }}
            placeholder={t(placeholderKey)}
            sx={{ width: '100%', ...inputSx }}
          />
        }
        onSubmit={(startDate, endDate) => {
          onStartDateChange(startDate)
          onEndDateChange(endDate)
          onSubmit(startDate, endDate)
          trackEvent('filter_changed', {
            filter_name: analyticsName,
            filter_value: getDateRangeKind(startDate, endDate),
          })
        }}
      />
    </FormProvider>
  )
}

export default DateFilter
